/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import React from 'react';
import { useListDataIntegrationConnectionsQuery } from '../../../../../api/initiative-data-integrations';
import { SemanticModelConfigTab } from './SemanticModel/SemanticModelConfigTab';
import { Spinner } from 'reactstrap';
import { BasicAlert } from '@g17eco/molecules/alert';

interface SemanticModelsTabProps {
  initiativeId: string;
}

export const SemanticModelsTab: React.FC<SemanticModelsTabProps> = ({ initiativeId }) => {
  const {
    data: connections = [],
    isLoading: connectionsLoading,
  } = useListDataIntegrationConnectionsQuery({ initiativeId });

  if (connectionsLoading) {
    return (
      <div className='text-center my-4'>
        <Spinner color='primary' />
        <div className='mt-2'>Loading data connections...</div>
      </div>
    );
  }

  if (connections.length === 0) {
    return (
      <BasicAlert type='info' className='text-center'>
        <i className='fal fa-info-circle me-2' />
        No data connections found. Add some data connections first to configure semantic models.
      </BasicAlert>
    );
  }

  // Use the first connection for semantic model configuration
  const firstConnection = connections[0];

  if (!firstConnection) {
    return (
      <BasicAlert type='info' className='text-center'>
        <i className='fal fa-info-circle me-2' />
        No data connections found. Add some data connections first to configure semantic models.
      </BasicAlert>
    );
  }
  return (
    <SemanticModelConfigTab
      initiativeId={initiativeId}
      connectionId={firstConnection.id}
    />
  );
};
